import { Spin } from "antd";
import React from "react";
import { IconSpin } from "../../../assets/icon";

const Loading = ({ isloading, children }) => {
  return (
    <>
      <Spin indicator={<IconSpin className="iconSpin" />} spinning={isloading}>
        {children}
      </Spin>
    </>
  );
};

export default Loading;
